const PageLoader = () => (
  <div className="min-h-screen bg-void flex flex-col items-center justify-center gap-4">
    <span className="font-mono text-primary text-2xl animate-pulse">//</span>
    <span className="font-mono text-xs tracking-[0.3em] uppercase text-void-muted animate-pulse">
      Initializing...
    </span>
  </div>
);

export default PageLoader;
